import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const STATUSES = ["requested","accepted","refunded","rejected"];

export default function AdminReturns() {
  const [returns, setReturns] = useState([]);
  const load = () => api.get("/admin/returns").then(r=>setReturns(r.data));
  useEffect(() => { load(); }, []);
  const update = async (id, patch) => { await api.put(`/admin/returns/${id}`, patch); toast.success("Mis à jour ✿"); load(); };
  return (
    <div className="p-4 sm:p-6 lg:p-10">
      <p className="overline text-berulia-rosedeep">BERULIA</p>
      <h1 className="font-heading text-3xl sm:text-4xl mt-2 mb-8">Retours & Remboursements</h1>
      <div className="bg-white border border-berulia-border overflow-x-auto">
        <table className="w-full text-sm whitespace-nowrap">
          <thead className="bg-berulia-beigewarm"><tr><th className="text-left p-3">Date</th><th className="text-left p-3">Commande</th><th className="text-left p-3">Email</th><th className="text-left p-3">Motif</th><th className="text-left p-3">Statut</th></tr></thead>
          <tbody>
            {returns.map(r => (
              <tr key={r.id} className="border-t border-berulia-border">
                <td className="p-3">{new Date(r.created_at).toLocaleDateString("fr-FR")}</td>
                <td className="p-3 overline">{r.order_number}</td>
                <td className="p-3">{r.customer_email}</td>
                <td className="p-3">{r.reason}</td>
                <td className="p-3"><select value={r.status} onChange={e=>update(r.id, {status:e.target.value})} className="border border-berulia-border px-2 py-1 bg-white">{STATUSES.map(s=><option key={s} value={s}>{s}</option>)}</select></td>
              </tr>
            ))}
            {returns.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-berulia-inkmuted">Aucune demande.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
